<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready">
            <div class="card mb-5">
                <div class="card-title" v-once>
                    <span v-if="editing">Фонд – {{ entry.name }}</span>
                    <span v-else>Создать фонд</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Название"
                            v-model="entry.name"
                            :errors="errors.name"
                            required
                        />

                        <text-field
                            type="number"
                            class="w-1/2 px-2"
                            title="Баланс"
                            v-model="entry.balance"
                            :errors="errors.balance"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Базовая комиссия (Продажа), %"
                            min="0"
                            max="100"
                            v-model="entry.base_distribution"
                            :errors="errors.base_distribution"
                            required
                        />

                        <text-field
                            class="w-1/2 px-2"
                            title="Базовая комиссия (Аренда), %"
                            min="0"
                            max="100"
                            v-model="entry.base_distribution_rent"
                            :errors="errors.base_distribution_rent"
                            required
                        />
                    </div>

                    <hr class="mb-3" />
                    <router-link
                        class="btn btn-warning"
                        :to="{
                            name: 'admin.billing.withdrawal.funds.form',
                            params: {id: this.entry.id}
                        }"
                    >Снять средства</router-link>
                    <button class="btn btn-primary">Сохранить</button>

                    <button v-if="editing" @click.prevent="destroy" class="btn btn-danger">Удалить</button>
                </form>
            </div>

            <distributions
                v-if="can('access-transactions') && editing"
                modelType="fund"
                :modelId="entry.id"
            />

            <transactions
                v-if="can('access-transactions') && editing"
                modelType="fund"
                :modelId="entry.id"
            />
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Distributions from "@/views/admin/distributions/form";
import Transactions from "@/views/admin/billing/transactions/index";

export default {
    extends: ResourceForm,

    components: {
        Distributions,
        Transactions
    },

    data() {
        return {
            resource: {
                name: "admin.assets.funds",
                endpoint: "admin/assets/funds"
            }
        };
    },

    methods: {},

    mounted() {}
};
</script>